<template>
    <v-dialog persistent v-model="copyrightDialog" max-width="700px">
        <v-card>
            <v-card-title>
                <h2 style="font-size: 20px !important;" class="headline-title">
                    Attention : certaines photos n'ont pas de copyright
                </h2>
            </v-card-title>
            <v-card-text>
                <h3 class="mt-2 headline-title" style="font-size: 14px">Qu'est-ce que le copyright ?</h3>

                <div>
                    Le copyright est un libellé qui désigne l'identité du titulaire des droits de la photo
                    (personne physique ou personne morale). Il atteste que l'auteur est d'accord que
                    vous diffusiez ses photos.
                </div>

                <h3 class="mt-4 headline-title" style="font-size: 14px">Connaissez-vous l'auteur des photos ?</h3>

                <div>
                    Si oui, et que celui-ci vous a octroyé les droits d'utilisation de la photo, alors vous
                    pouvez indiquer son nom en tant que copyright. Sinon il est préférable de ne pas diffuser la
                    photo (et de la retirer de ce formulaire).
                </div>

                <h3 class="mt-4 headline-title" style="font-size: 14px">Pourquoi est-ce important de saisir un copyright ?</h3>

                <div>
                    Sans copyright, l'auteur de la photo peut se retourner contre nous et réclamer des
                    réparations pour diffusion de la photo sans autorisation.
                    Pour éviter cette situation, nous ne diffusons pas de photos sans copyright.
                </div>

                <v-spacer></v-spacer>

                <div class="d-md-flex justify-content-between mt-5">
                    <v-btn class="text-none mt-3" color="error" outlined @click="confirmCopyrights">
                        Valider sans mes copyrights
                    </v-btn>

                    <v-btn class="text-none mt-3" color="success" outlined @click="scrollToMedias()">
                        Ajouter mes copyrights
                    </v-btn>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import {mapState, mapMutations} from "vuex"
export default {
    name: "CopyrightModal",
    methods: {
        ...mapMutations('web_form', ['setCopyrightDialog', 'confirmCopyrightDialog']),
        scrollToMedias() {
            this.setCopyrightDialog(false)

            this.$global.$emit('scroll-tab', 'media-tab')
        },
        confirmCopyrights() {
            this.confirmCopyrightDialog()

            this.$global.$emit('trigger-save')
        }
    },
    computed: {
        ...mapState('web_form', ['copyrightDialog'])
    }
}
</script>

